export const EnrollmentConstants = Object.freeze({

  //Status
	ACTIVE: "ACTIVE",
	ENROLLED: "ENROLLED",
	ORDERED: "ORDERED",
	DELIVERED: "DELIVERED",
	DELETED: "DELETED",
	INACTIVE: "INACTIVE",
	ASSIGNED: "ASSIGNED",
	UNENROLLED: "UNENROLLED",
	NOT_ENROLLED: "NOT_ENROLLED",

	ENROLLMENT_DATE: "Enrollment Date",
	ORDERED_DATE: "Order Date",
	DELIVERY_DATE: "Delivery Date",
	DELETED_DATE: "Deleted Date",
	UNENROLLMENT_DATE: "Unenrollment Date",
	STATUS_UPDATED_DATE: "Status Updated Date",
	ENROLL_NOW: "Enroll Now",
	UNENROLL_NOW: "Unenroll Now",
	
	ENROLLMENT_CANCELED: "ENROLLMENT_CANCELED",
	ENROLLMENT_FAILED: "ENROLLMENT_FAILED",
	ENROLLMENT_INITIATED: "ENROLLMENT_INITIATED",
	ENROLLMENT_IN_PROGRESS: "ENROLLMENT_IN_PROGRESS",
	ENROLLMENT_RETRY: "ENROLLMENT_RETRY",
	UNENROLLMENT_CANCELED: "UNENROLLMENT_CANCELED",
	UNENROLLMENT_FAILED: "UNENROLLMENT_FAILED",
	UNENROLLMENT_INITIATED: "UNENROLLMENT_INITIATED",
	UNENROLLMENT_IN_PROGRESS: "UNENROLLMENT_IN_PROGRESS",
	UNENROLLMENT_RETRY: "UNENROLLMENT_RETRY"
});